import { render, staticRenderFns } from "./wp_img.vue?vue&type=template&id=283fd360&scoped=true&"
import script from "./wp_img.vue?vue&type=script&lang=js&"
export * from "./wp_img.vue?vue&type=script&lang=js&"
import style0 from "./wp_img.vue?vue&type=style&index=0&id=283fd360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283fd360",
  null
  
)

export default component.exports